import formatTablePart from "./part-format-table.js";
import formatTablev2Part from "./part-format-tablev2.js";
//import formatChartPart from ".//part-format-chart.js";

export default function(_DSB,_CONTEXT={}){
  let FORMAT_TYPES = {};
  FORMAT_TYPES['formatTablePart']=formatTablePart(_DSB,_CONTEXT);
  FORMAT_TYPES['formatTablev2Part']=formatTablev2Part(_DSB,_CONTEXT);

  return function (inputData = null, inputDataFormat = {}, formatType = 'table') {
    formatType=formatType.split('|');
    let formatTypeOptions=(formatType.length==2?formatType[1]:'');
    formatType = formatType[0].charAt(0).toUpperCase() + formatType[0].slice(1).toLowerCase();

    let formatTable = formatTablePart(_DSB,_CONTEXT);

    // BAIL early if no data at all, or the correct data is not found
    if (!inputData) { throw "No JSON input for .table()"; }

    // if (inputDataFormat.y !== undefined && inputDataFormat.y.fields === undefined) { return Promise.reject( GeneralError(`No fields found in 'y' data field`) ); }

    let chartElementID;
    let chartDateFormat;

    // BAIL if no _valid JSON_ data
    // ..by trying to put it through JSON.parse()
    let jsonData = typeof inputData !== `string` ? JSON.stringify(inputData) : inputData;
    try { jsonData = JSON.parse(jsonData); } catch(err) { throw "Invalid JSON input for .format()"; }

    let data = jsonData.data || jsonData;
    let dataObj = data;
    let xLabel, yLabel, formatHandler;

    if (Object.keys(inputDataFormat).length) {
      if (inputDataFormat.x === undefined) {throw "No 'x' field found in inputDataFormat";}
      if (inputDataFormat.x.fields === undefined || !inputDataFormat.x.fields.length) { throw "No fields found in 'x' data field"; }

      if (formatType === `Chart`) {
        chartElementID = inputDataFormat.elementID || `#chart`;
        if (inputDataFormat.x.fields[0].format) {
          let format = inputDataFormat.x.fields[0].format.split(`|`);
          if (format[0] === `date` && format[1]) {
            chartDateFormat = format[1].split(`:`)[1];
          }
        }
      }

      [ dataObj, xLabel, yLabel ] = _DSB.helpers.run('format','structure',[data,inputDataFormat]);
    }

    let sort = inputDataFormat.sort && Object.keys(inputDataFormat.sort).length ? inputDataFormat.sort : {};
    let limit = !isNaN(parseInt(inputDataFormat.limit, 10)) && inputDataFormat.limit >= 0 ? inputDataFormat.limit : data.length;

    if(typeof FORMAT_TYPES['format'+formatType+'Part'] === 'function')
    {
      return FORMAT_TYPES['format'+formatType+'Part'](dataObj, yLabel, limit, sort, formatTypeOptions);
    }
    else
    {
      // Run any format filters
      if (_DSB.filters.has('format'+formatType+'Part'))
      {
        [ formatType, dataObj, xLabel, yLabel, chartElementID, chartDateFormat, limit, sort ] = _DSB.filters.apply('format'+formatType+'Part', [ formatType, dataObj, xLabel, yLabel, chartElementID, chartDateFormat, limit, sort ,formatTypeOptions] );
      }
    }
    return dataObj;
  }
}
